import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/leave_requests',
    name: 'AdminLeaveRequest',
    component: {
      name: 'AdminLeaveRequests',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'leave_request',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminLeaveRequestIndex',
        component: () => import('../views/admin/LeaveRequestsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminLeaveRequestNew',
        component: () => import('../views/admin/LeaveRequestInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminLeaveRequestIndex' },
        },
      },
      {
        path: 'batch_new',
        name: 'AdminLeaveRequestBatchNew',
        component: () => import('../views/admin/LeaveRequestBatchInput.vue'),
        meta: {
          action: 'new',
          customName: 'views.leave_request.index.batch_new',
          backRoute: { name: 'AdminLeaveRequestIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminLeaveRequestShow',
        component: () => import('../views/admin/LeaveRequestShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminLeaveRequestIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminLeaveRequestDetails',
            component: () => import('../views/admin/LeaveRequestDetails.vue'),
            meta: {
              backRoute: { name: 'AdminLeaveRequestIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminLeaveRequestEdit',
            component: () => import('../views/admin/LeaveRequestInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminLeaveRequestIndex' },
            },
          },
          {
            path: 'phases',
            name: 'AdminLeaveRequestPhases',
            component: () => import('../views/admin/LeaveRequestPhases.vue'),
            meta: {
              backRoute: { name: 'AdminLeaveRequestsIndex' },
              resource: 'phase',
            },
          },
          {
            path: 'logs',
            name: 'AdminLeaveRequestLogs',
            component: () => import('../views/admin/log/LeaveRequestLogs.vue'),
            meta: {
              backRoute: { name: 'AdminLeaveRequestIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ],
  },
  {
    path: 'user/leave_requests',
    name: 'UserLeaveRequest',
    component: {
      name: 'UserLeaveRequests',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'leave_request',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'UserLeaveRequestIndex',
        component: () => import('../views/user/LeaveRequestsIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'UserLeaveRequestNew',
        component: () => import('../views/user/LeaveRequestInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'UserLeaveRequestIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'UserLeaveRequestShow',
        component: () => import('../views/user/LeaveRequestShow.vue'),
        meta: {
          backRoute: {
            name: 'UserLeaveRequestIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'UserLeaveRequestDetails',
            component: () => import('../views/user/LeaveRequestDetails.vue'),
            meta: {
              backRoute: { name: 'UserLeaveRequestIndex' },
            },
          },
        ],
      },
    ],
  },
  {
    path: 'user/absence_overview',
    name: 'UserAbsenceOverview',
    component: () => import('../views/user/AbsenceOverview.vue'),
    meta: {
      backRoute: { name: 'dashboard' },
      resource: 'absence_overview',
    },
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));